import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-phone-callback",
  templateUrl: "./med-icon-phone-callback.component.html",
})
export class MedIconPhoneCallbackComponent extends SvgMixinComponent {}
